export default "__VITE_ASSET__CmAjFaPq__"